<script setup lang="ts">
const { resetWizard } = useOfferteWizard()
</script>

<template>
  <section class="pa-wizard__panel pa-wizard__success">
    <div class="pa-wizard__success-check" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </div>
    <h2>Bedankt, je aanvraag is verstuurd!</h2>
    <p>
      We hebben je samenstelling ontvangen en nemen <strong>binnen 2 werkdagen</strong> contact met je op voor je persoonlijke offerte. Je ontvangt ook een bevestiging per e-mail.
    </p>
    <div class="pa-wizard__success-actions">
      <NuxtLink to="/" class="pa-btn pa-btn--primary">Terug naar de website</NuxtLink>
      <button type="button" class="pa-wizard__success-restart" @click="resetWizard">Nieuwe aanvraag starten</button>
    </div>
  </section>
</template>
